import { memo, useEffect } from "react";
import { Link } from "react-router-dom";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

import { useConnectionStore } from "stores/ConnectionStore";

import { getConnectedServices } from "utility/connections";

import useAnalytics from "effect/use_analytics";

import Sources from "external/sources";

import ConnectedSources from "./ConnectedSources";
import PossibleSources from "./PossibleSources";

// -----------------------------------------------------------------------------

const EnvironmentSources = memo(function EnvironmentSources(): JSX.Element {
  useAnalytics("Environment: Sources");

  //
  const [connectionStore, connectionActions] = useConnectionStore();

  //
  useEffect(() => {
    connectionActions.loadConnections({ reload: true });
  }, [connectionActions]);

  //
  const connectedSourcesCount = getConnectedServices(
    connectionStore?.connections,
    Sources.services
  ).length;

  //
  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          alignItems: "center",
          mb: 1,
        }}
      >
        <Typography variant="h5" fontWeight="bold" sx={{ mr: 2 }}>
          Available Sources
        </Typography>
        <Link
          to="/environment/sources/all"
          style={{
            alignItems: "center",
            display: "flex",
            textDecoration: "none",
            textTransform: "uppercase",
          }}
        >
          <Typography variant="body1" color="primary">
            See All Available
            <ArrowForwardIcon sx={{ ml: "4px", width: 16, height: 16 }} />
          </Typography>
        </Link>
      </Box>

      <PossibleSources />

      {connectedSourcesCount > 0 ? (
        <Box sx={{ mt: 4 }}>
          <Typography gutterBottom variant="h5" fontWeight="bold">
            Connected Sources ({connectedSourcesCount})
          </Typography>

          <ConnectedSources />
        </Box>
      ) : null}
    </>
  );
});

export default EnvironmentSources;
